var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from '@inertiajs/react';
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
export default function ClientFormSteps(_a) {
    var step = _a.step, clientForm = _a.clientForm;
    var route = useRoute(Ziggy);
    var steps = [
        { id: 'Start', name: 'start', href: route('client-public-form', { clientForm: clientForm }), status: 'complete' },
        { id: 'Details', name: 'step-1', href: route('client-public-form.step-1', { clientForm: clientForm }), status: 'current' },
        { id: 'Travel details', name: 'step-2', href: route('client-public-form.step-2', { clientForm: clientForm }), status: 'upcoming' },
        { id: 'Pets', name: 'step-3', href: route('client-public-form.step-3', { clientForm: clientForm }), status: 'upcoming' },
        { id: 'Supporting documents', name: 'step-4', href: route('client-public-form.step-4', { clientForm: clientForm }), status: 'upcoming' },
        { id: 'Confirm', name: 'step-5', href: route('client-public-form.step-5', { clientForm: clientForm }), status: 'upcoming' },
    ];
    for (var i = 0; i < steps.length; i++) {
        var _step = steps[i];
        if (i === step) {
            _step.status = 'current';
        }
        if (i > step) {
            _step.status = 'upcoming';
        }
        if (i < step) {
            _step.status = 'complete';
        }
        // if (i > 0 && !certificate.client) {
        //     _step.status = 'disabled';
        // }
    }
    return (_jsx("nav", __assign({ "aria-label": "Progress" }, { children: _jsx("ol", __assign({ role: "list", className: "space-y-4 md:flex md:space-y-0 md:space-x-8" }, { children: steps.map(function (step) { return (_jsx("li", __assign({ className: "md:flex-1" }, { children: step.status === 'complete' ? (_jsx(Link, __assign({ href: step.href, className: "group pl-4 py-2 flex flex-col border-l-4 border-indigo-600 hover:border-indigo-800 md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4" }, { children: _jsx("span", __assign({ className: "text-sm text-indigo-600 font-medium group-hover:text-indigo-800" }, { children: step.id })) }))) : step.status === 'current' ? (_jsx(Link, __assign({ href: step.href, className: "pl-4 py-2 flex flex-col border-l-4 border-indigo-600 md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4", "aria-current": "step" }, { children: _jsx("span", __assign({ className: "text-sm text-indigo-600 font-medium" }, { children: step.id })) }))) : (_jsx(Link, __assign({ href: step.href, className: "group pl-4 py-2 flex flex-col border-l-4 border-gray-200 hover:border-gray-300 md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4" }, { children: _jsx("span", __assign({ className: "text-sm text-gray-500 font-medium group-hover:text-gray-700" }, { children: step.id })) }))) }), step.name)); }) })) })));
}
